(ns practitest.frontend.users-view.utils
  (:require [clojure.string :as str]
            [practitest.frontend.common.i18n :refer [get-translation format-translation]]
            [practitest.frontend.common.utils :as common-utils]))

(def table-id "users-view-index")

(def selection-path [:users-view :users-view-index])

(def pat-states ["disabled" "enabled" "enabled_with_impersonation"])

(defn pat-state-label [pat-state]
  (case pat-state
    "disabled" (get-translation "generic.label.disabled" "Disabled")
    "enabled" (get-translation "generic.label.enabled" "Enabled")
    "enabled_with_impersonation" (get-translation "users-view.pat-state.enabled-with-impersonation" "Enabled with Impersonation")
    pat-state))

(defn pat-label->state [label]
  (or (some #(when (= label (pat-state-label %)) %) pat-states)
      label))

;; Groups belong to a project and their names repeat across projects, so the
;; groups filter offers group/project pairs rather than bare group names.
(defn group-filter-label [group-name project-name]
  (format-translation
    (get-translation "users-view.groups-filter.option" "%{group} - %{project}")
    :group group-name
    :project project-name))

(defn group-label->id [all-groups label]
  (some #(when (= label (group-filter-label (:name %) (:project_name %))) (:id %))
        all-groups))

(defn invite-email-error [emails {:keys [existing-emails] :as invite-form}]
  (let [multiple? (> (count emails) 1)
        invalid-emails (distinct (concat (remove common-utils/email? emails) (:invalid-emails invite-form)))]
    (cond
      (and (seq invalid-emails) (not multiple?))
      (get-translation "generic.validation.invalid-email" "This email is not valid")

      (seq invalid-emails)
      (format-translation
        (get-translation "generic.validation.invalid-emails" "These emails are not valid: %{emails}")
        :emails (str/join ", " invalid-emails))

      (and (seq existing-emails) (not multiple?))
      (get-translation "users-view.new-user.email-exists" "This email already exists")

      (seq existing-emails)
      (format-translation
        (get-translation "users-view.new-user.emails-exist" "These emails already exist: %{emails}")
        :emails (str/join ", " existing-emails)))))

(defn project-groups-complete? [{:keys [project-groups]}]
  (boolean (and (seq project-groups)
                (every? #(and (:project-id %) (seq (:group-ids %))) project-groups))))
